export { CheckpointText } from './CheckpointText';
export { CheckpointNumber } from './CheckpointNumber';
export { CheckpointRange } from './CheckpointRange';
export { CheckpointDropdown } from './CheckpointDropdown';
export { CheckpointDate } from './CheckpointDate';
export { CheckpointFile } from './CheckpointFile';
export { CheckpointUnits } from './CheckpointUnits';
export { CheckpointUser } from './CheckpointUser';
export { CheckpointLink } from './CheckpointLink';

import type { ExecuteCheckpointFieldType } from '@/types/run-stage.types';
import { CheckpointText } from './CheckpointText';
import { CheckpointNumber } from './CheckpointNumber';
import { CheckpointRange } from './CheckpointRange';
import { CheckpointDropdown } from './CheckpointDropdown';
import { CheckpointDate } from './CheckpointDate';
import { CheckpointFile } from './CheckpointFile';
import { CheckpointUnits } from './CheckpointUnits';
import { CheckpointUser } from './CheckpointUser';
import { CheckpointLink } from './CheckpointLink';

/**
 * Map from checkpoint fieldType to the React component that renders it.
 * Note: 'group' type is handled directly by CheckpointList, not via this map.
 */
export const CHECKPOINT_COMPONENT_MAP: Record<
  ExecuteCheckpointFieldType,
  React.ComponentType<any>
> = {
  text: CheckpointText,
  textNumber: CheckpointText,
  number: CheckpointNumber,
  date: CheckpointDate,
  user: CheckpointUser,
  dropdown: CheckpointDropdown,
  linkEntity: CheckpointLink,
  file: CheckpointFile,
  units: CheckpointUnits,
  group: CheckpointText, // handled by CheckpointList directly; fallback only
  range: CheckpointRange,
  table: CheckpointText, // fallback to text for table
  gradientProgram: CheckpointText, // fallback to text for gradient
};
